const c = (o) => (e) => {
  o.forEach((t) => {
    typeof t == "function" ? t(e) : t && (t.current = e);
  });
};
export {
  c as default
};
//# sourceMappingURL=mergeRefs.js.map
